import { render, staticRenderFns } from "./finalizeSoRegisteration.vue?vue&type=template&id=b25fc9c4"
import script from "./finalizeSoRegisteration.vue?vue&type=script&lang=js"
export * from "./finalizeSoRegisteration.vue?vue&type=script&lang=js"
import style0 from "./finalizeSoRegisteration.vue?vue&type=style&index=0&id=b25fc9c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports